import { Component } from '@angular/core';

@Component({
  selector: 'ins-login-page',
  templateUrl: './login-page.component.html',
})
export class LoginPageComponent {}
